import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { portalApi } from '../services/portalApi';
import { queryKeys } from './queryKeys';

const EMPTY = [];

export function useContacts({ type, search = '', page = 1, pageSize = 200 } = {}) {
  const params = { type: type || undefined, search: search || undefined, page, limit: pageSize };
  const query = useQuery({
    queryKey: queryKeys.contacts.list(params),
    queryFn: () => portalApi.contactList(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000
  });
  return {
    rows: query.data?.docs || EMPTY,
    total: query.data?.totalDocs || 0,
    counts: query.data?.counts || {},
    isLoading: query.isLoading,
    error: query.error
  };
}

export function useContactByName() {
  const { rows } = useContacts({ pageSize: 200 });
  return (name, types) => {
    const key = String(name || '').trim().toLowerCase();
    return key ? rows.find((c) => c.name.trim().toLowerCase() === key && (!types || types.includes(c.type))) : null;
  };
}
